import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:3001') + '/api';

// Account switcher for people who belong to a team (and may also sell their own
// cards). Lets them flip between their Personal account and any team they're an
// active member of. Renders NOTHING for solo users (no teams), so it's invisible
// to everyone who isn't on a team. Switching stores the context and reloads so
// every page re-fetches its data in the new account.
export default function AccountSwitcher({ expanded = true }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    axios.get(`${API}/team/contexts`)
      .then(res => { if (alive) setData(res.data); })
      .catch(() => { if (alive) setData({ teams: [] }); });
    return () => { alive = false; };
  }, []);

  if (!data || !data.teams || data.teams.length === 0) return null; // solo user, nothing to switch

  const current = data.current || 'personal';
  const switchTo = (value) => {
    if (value === current) return;
    try {
      if (value === 'personal') localStorage.removeItem('scn-context');
      else localStorage.setItem('scn-context', value);
    } catch { /* ignore */ }
    window.location.assign('/'); // full reload so all data re-fetches in the new account
  };

  const personalLabel = data.personal?.name || data.personal?.email || 'Personal';

  if (!expanded) {
    // Collapsed rail: a small indicator of the active account (hover expands the rail).
    const inTeam = current !== 'personal';
    const letter = inTeam
      ? (data.teams.find(t => t.ownerUserId === current)?.name || 'T').charAt(0).toUpperCase()
      : 'P';
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '6px 0' }} title="Switch account">
        <div style={{
          width: 26, height: 26, borderRadius: 7, display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 12, fontWeight: 700, color: '#fff',
          background: inTeam ? '#1c56cc' : 'rgba(255,255,255,0.12)',
        }}>{letter}</div>
      </div>
    );
  }

  return (
    <div style={{ padding: '8px 10px' }}>
      <div style={{ fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px', color: 'rgba(255,255,255,0.4)', marginBottom: 5 }}>
        Account
      </div>
      <select
        value={current}
        onChange={(e) => switchTo(e.target.value)}
        style={{
          width: '100%', padding: '7px 9px', borderRadius: 7, fontSize: 13, fontWeight: 500,
          background: 'rgba(255,255,255,0.06)', color: '#fff', cursor: 'pointer',
          border: '1px solid rgba(255,255,255,0.12)', fontFamily: 'inherit', outline: 'none',
        }}
      >
        <option value="personal" style={{ color: '#111' }}>{personalLabel} (Personal)</option>
        {data.teams.map(t => (
          <option key={t.ownerUserId} value={t.ownerUserId} style={{ color: '#111' }}>
            {t.name} (Team)
          </option>
        ))}
      </select>
    </div>
  );
}
